import {Icon} from './Icon';
export {icon} from './Icon';
import {IconDefault} from './Icon.Default';
Icon.Default = IconDefault;
export {Icon};

export {DivIcon, divIcon} from './DivIcon';
export {Marker, marker} from './Marker';



// WEBPACK FOOTER //
// ../src/layer/marker/index.js